module.exports = __webpack_public_path__ + "img/a.07df9dd7.jpg";